import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref } from 'vue';

import {
  Row,
  HeadingDisplay,
  BaseText,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { SingleInputMoney } from '@/modules/common/components/SingleInputMoney';

import { formatCurrency } from '@/modules/common/helpers/currency';

import { IWithdrawDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Withdraw',
  setup(__props) {

const changeAmountValue = inject('changeAmountValue', (value: number) => ({
  value
}));

const withdrawDetails = inject('withdrawDetails') as Ref<IWithdrawDetails>;

const amountValue = ref(0);

const isDisabled = computed(() => {
  return amountValue.value <= 0 || status.value === 'error';
});

const portfolioName = computed(() => {
  return withdrawDetails.value?.portfolioName ?? '';
});

const minimumRedemption = computed(() => {
  return withdrawDetails.value.minimumRedemption.value;
});

const totalBalance = computed(() => {
  return withdrawDetails.value.totalBalance.value;
});

const restValue = computed(() => {
  return totalBalance.value - amountValue.value;
});

const maximumRedemption = computed(() => {
  return formatCurrency(
    totalBalance.value - withdrawDetails.value.minimumStayValue.value
  );
});

const status = computed(() => {
  return (amountValue.value < minimumRedemption.value &&
    amountValue.value !== 0) ||
    amountValue.value > totalBalance.value ||
    (restValue.value > 0 &&
      restValue.value < withdrawDetails.value.minimumStayValue.value)
    ? 'error'
    : '';
});

const helperText = computed(() => {
  if (amountValue.value < minimumRedemption.value && amountValue.value !== 0)
    return `O valor mínimo de resgate é de ${withdrawDetails.value.minimumRedemption.formatted}. Escolha um valor maior ou igual para resgatar.`;
  if (amountValue.value > totalBalance.value)
    return `O saldo desta carteira é de ${withdrawDetails.value.totalBalance.formatted}. Escolha um valor menor ou igual para resgatar.`;
  if (
    restValue.value > 0 &&
    restValue.value < withdrawDetails.value.minimumStayValue.value
  )
    return `O valor mínimo de permanência é de ${withdrawDetails.value.minimumStayValue.formatted}. Escolha um valor inferior a R$ ${maximumRedemption.value} ou solicite o resgate total.`;

  return '';
});

const listDetails = computed(() => {
  const list = [
    {
      title: 'Mínimo para resgate',
      value: withdrawDetails.value.minimumRedemption.formatted,
      show: Boolean(withdrawDetails.value.minimumRedemption)
    },
    {
      title: 'Mínimo de permanência',
      value: withdrawDetails.value.minimumStayValue.formatted,
      show: Boolean(withdrawDetails.value.minimumStayValue)
    },
    {
      title: 'Prazo total de resgate',
      value: withdrawDetails.value.totalRedemptionDays,
      show: Boolean(withdrawDetails.value.totalRedemptionDays)
    }
  ];

  return list.filter(item => item.show);
});

function withdrawClick() {
  changeAmountValue(amountValue.value);
}

function onChangeValue(data: { value: number }) {
  amountValue.value = data.value;
}

return { __sfc: true,changeAmountValue, withdrawDetails, amountValue, isDisabled, portfolioName, minimumRedemption, totalBalance, restValue, maximumRedemption, status, helperText, listDetails, withdrawClick, onChangeValue, Row, HeadingDisplay, BaseText, ListDisplay, ButtonContainer, ButtonPrimary, NebraskaColors, SingleInputMoney }
}

})